import React, {useEffect, useState} from 'react';
import {Grid, TextField} from '@material-ui/core';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    plate: {
      display: 'flex',
      flexDirection: 'row',
      backgroundImage: 'url("/motor-plate.jpeg")',
      width: '120px',
      height: '80px',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      marginLeft: '8px',
      marginTop: '5px',
      paddingRight: '26px',
      '& .MuiInputBase-root': {
        height: '40px',
        marginTop: '0',
      },
      '& .MuiTextField-root': {
        height: '15px',
      }
    },
    input: {
      width: '100%',
      textAlign: 'center',
      height: '10px',
    },
    inputWrapper: {
    }
  })
);

export type Props = {
  getNumber: (number: string) => void;
  number?: string;
};

function MotorPlate(props: Props) {
  const classes = useStyles();
  const [firstDigit, setFirstDigit] = useState('');
  const [secondDigit, setSecondDigit] = useState('');

  useEffect(() => {
    const number = firstDigit.concat(secondDigit)
    props.getNumber(number);
    if (!number) {
      props.getNumber('');
    }
  }, [firstDigit, secondDigit]);

  useEffect(() => {
    if (props.number?.length === 8) {
      setFirstDigit(props.number.substring(0, 3));
      setSecondDigit(props.number.substring(3, 8));
    }
  }, [props.number]);

  return (
    <Grid className={classes.plate} container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <TextField
          inputProps={{
            className: classes.input,
          }}
          onInput={e => {
            const value = parseInt(e.target.value);
            e.target.value = isNaN(value)
              ? ''
              : Math.max(0, value).toString().slice(0, 3);
          }}
          value={firstDigit}
          onChange={e => setFirstDigit(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          inputProps={{
            className: classes.input,
          }}
          onInput={e => {
            const value = parseInt(e.target.value);
            e.target.value = isNaN(value)
              ? ''
              : Math.max(0, value).toString().slice(0, 5);
          }}
          value={secondDigit}
          onChange={e => setSecondDigit(e.target.value)}
        />
      </Grid>
    </Grid>
  );
}

export default MotorPlate;
